import { t } from "@lingui/macro";
import { AnimatePresence, MotiView } from "moti";

import { TeeSheetInfoCard } from "@whoosh/design-system/src/apps/PatronApp/screens/teesheet/components/TeeSheetInfoCard/TeeSheetInfoCard";
import { BlockIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { Box } from "@whoosh/design-system/src/components/primitive";
import { getLightSurfaceColor } from "@whoosh/utilities/src/colors";

import { useRestrictionBlockData } from "../../../../../Common/hooks/useRestrictionBlockData";
import {
  CustomColor,
  RestrictionMemberVisibility,
} from "../__generated__/TimeSlotListInternalQuery.graphql";
import { RestrictionBlockFooter } from "./RestrictionBlockFooter";

export type RestrictionBlockProps = {
  id: string;
  name: string;
  displayName: string | null;
  startAt: string | null;
  displayStartAt?: string | null;
  liftAt?: string | null;
  endAt: string | null;
  courseMessage?: string | null;
  memberMessage?: string | null;
  allDay: boolean;
  visibility?: RestrictionMemberVisibility | null;
  visibilityColor?: CustomColor | null;
  serverTimeOffsetMs?: number | null;
};

export const RestrictionBlock = ({
  name,
  displayName,
  liftAt,
  startAt,
  displayStartAt,
  visibility,
  visibilityColor,
  courseMessage,
  memberMessage,
  endAt,
  allDay,
  serverTimeOffsetMs,
}: RestrictionBlockProps) => {
  const restrictionBackgroundColor = visibilityColor
    ? getLightSurfaceColor(visibilityColor)
    : "grayscale-800";

  const { subtitle, showRotatingBorder, hideCard } = useRestrictionBlockData({
    startAt,
    endAt,
    displayStartAt,
    liftAt,
    allDay,
    serverTimeOffsetMs,
  });

  return visibility === "RESTRICTION_ONLY" ||
    visibility === "SLOTS_AND_RESTRICTION" ? (
    <AnimatePresence>
      {!hideCard ? (
        <MotiView
          from={{ opacity: 1, maxHeight: 2000 }}
          animate={{ opacity: 1, maxHeight: 2000 }}
          exit={{ opacity: 0, maxHeight: 0 }}
          exitTransition={{
            opacity: {
              type: "timing",
              duration: 1000,
            },
            maxHeight: {
              type: "timing",
              duration: 1000,
            },
          }}
        >
          <Box alignItems="center" justifyContent="center" py={1} my={3}>
            <TeeSheetInfoCard
              title={displayName || name || ""}
              subTitle={subtitle}
              backgroundColor={restrictionBackgroundColor}
              bodyContent={memberMessage ?? courseMessage ?? ""}
              icon={<BlockIcon />}
              footer={
                <RestrictionBlockFooter
                  unlocksAt={liftAt}
                  serverTimeOffsetMs={serverTimeOffsetMs}
                />
              }
              courseNames={courseMessage ?? t`All Courses`}
              showRotatingBorder={showRotatingBorder}
            />
          </Box>
        </MotiView>
      ) : null}
    </AnimatePresence>
  ) : null;
};
